import api from './api';
import { Customer, CustomerStats } from '@/types/customer';
import { Order } from '@/types/order';

export const customerApi = {
    // Tüm müşterileri getir
    async getCustomers(): Promise<Customer[]> {
        try {
            console.log('🔍 Fetching customers...');
            const response = await api.get('/admin/customers');
            console.log('✅ Customers fetched:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('❌ Error fetching customers:', error);
            throw new Error(error.response?.data?.error || 'Müşteriler yüklenemedi');
        }
    },

    // Tek bir müşteriyi getir
    async getCustomer(customerId: string): Promise<Customer> {
        try {
            const response = await api.get(`/admin/customers/${customerId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching customer:', error);
            throw new Error(error.response?.data?.error || 'Müşteri yüklenemedi');
        }
    },

    // Müşterinin siparişlerini getir
    async getCustomerOrders(customerId: string): Promise<Order[]> {
        try {
            const response = await api.get(`/admin/customers/${customerId}/orders`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching customer orders:', error);
            throw new Error(error.response?.data?.error || 'Siparişler yüklenemedi');
        }
    },

    // Müşteri istatistikleri
    async getCustomerStats(): Promise<CustomerStats> {
        try {
            const response = await api.get('/admin/customers/stats');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching customer stats:', error);
            throw new Error(error.response?.data?.error || 'İstatistikler yüklenemedi');
        }
    },

    // Müşteri durumunu güncelle
    async updateCustomerStatus(
        customerId: string,
        status: 'active' | 'inactive' | 'blocked'
    ): Promise<Customer> {
        try {
            const response = await api.put(`/admin/customers/${customerId}/status`, { status });
            return response.data;
        } catch (error: any) {
            console.error('Error updating customer status:', error);
            throw new Error(error.response?.data?.error || 'Durum güncellenemedi');
        }
    },

    // Müşteri ara
    async searchCustomers(searchTerm: string): Promise<Customer[]> {
        try {
            const response = await api.get('/admin/customers/search', {
                params: { q: searchTerm },
            });
            return response.data;
        } catch (error: any) {
            console.error('Error searching customers:', error);
            throw new Error(error.response?.data?.error || 'Arama başarısız');
        }
    },

    // Müşteri ekle
    async createCustomer(customerData: Partial<Customer>): Promise<Customer> {
        try {
            const response = await api.post('/admin/customers', customerData);
            return response.data;
        } catch (error: any) {
            console.error('Error creating customer:', error);
            throw new Error(error.response?.data?.error || 'Müşteri oluşturulamadı');
        }
    },

    // Müşteri güncelle
    async updateCustomer(customerId: string, customerData: Partial<Customer>): Promise<Customer> {
        try {
            const response = await api.put(`/admin/customers/${customerId}`, customerData);
            return response.data;
        } catch (error: any) {
            console.error('Error updating customer:', error);
            throw new Error(error.response?.data?.error || 'Müşteri güncellenemedi');
        }
    },
};
